<div class="overflow-hidden h-screen">
  <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 w-full mt-1 pr-2">
    <div
      *ngFor="let card of cards"
      class="w-full rounded-md border border-gray-400 bg-white p-2"
      [style.height.px]="100"
      [style.minHeight.px]="100"
    >
      <div class="flex items-center justify-between">
        <div class="text-lightGray font-inter text-base font-normal leading-normal">
          {{ card.title }}
        </div>
      </div>

      <div class="self-stretch text-darkBlue font-inter text-2xl font-semibold leading-normal">
        {{ card.value }}
      </div>

      <div class="flex items-center text-sm">
        <span class="text-gray-500">
          {{ card.subtext }}
        </span>
        <div *ngIf="card.indicatorText !== ''" class="ml-2 inline-flex items-center" [ngClass]="card.indicatorClass">
          <img [src]="card.indicatorIcon" alt="Indicator" class="w-2 h-2" />
          <span class="ml-1" [ngClass]="card.textColor">
            {{ card.indicatorText }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <section
    id="map-id"
    class="mt-2 grid grid-cols-1 lg:grid-cols-4 border border-gray-400 rounded-md mr-2"
    style="height: calc(100vh - 130px)"
  >
    <div class="col-span-3 bg-white">
      <div class="bg-gray-100 flex items-center justify-center text-gray-400 h-full">
        <lohi-app-map [drivers]="allDrivers" [selectedDriver]="selectedDriver"></lohi-app-map>
      </div>
    </div>
    <div class="overflow-y-auto h-full w-full">
      <div class="bg-white flex flex-col rounded-md w-full">
        <div *ngIf="loadsNeedingAcceptance.length" class="border-b border-gray-300 pb-2 mb-2">
          <div class="text-gray-900 text-lg font-bold pt-2 mb-1 px-2 uppercase tracking-wide">Loads Needing Acceptance</div>
          <button
            type="button"
            *ngFor="let load of loadsNeedingAcceptance; trackBy: trackByLoadId"
            class="w-full text-left py-2 px-2 cursor-pointer rounded-md hover:bg-lightBlue2 border-0 bg-transparent border-l-4 border-l-orange-500 flex items-start justify-between gap-2"
            (click)="openLoadApprovalDialog(load)"
            matTooltip="Review and approve or reject"
          >
            <div class="min-w-0 flex-1">
              <div class="font-semibold text-black">{{ load.uniqueId }}</div>
              <div class="text-sm text-red-500 font-medium">{{ load.driverName }} - {{ load.originSiteName }} to {{ load.destinationSiteName }}</div>
            </div>
            <mat-icon class="text-orange-500 flex-shrink-0" aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>
        <mat-tab-group mat-stretch-tabs class="w-full" (selectedTabChange)="switchTab($event.index)">
          <mat-tab label="IN PROGRESS" style="font-size: 12px">
            <div class="pl-2">
              <div class="flex-grow mt-3">
                <ng-container *ngIf="filteredDrivers.length; else noDriverInProgress">
                  <ng-container *ngFor="let driver of filteredDrivers; let i = index; trackBy: identifyDriver">
                    <div
                      class="py-1 cursor-pointer rounded-md pl-1"
                      [ngClass]="{ 'bg-lightBlue2': selectedDriver?.driverId === driver.driverId }"
                      (click)="selectDriver(driver)"
                    >
                      <div class="font-semibold text-blue-500 text-lg">
                        {{ driver.driverName }}
                      </div>
                      <p class="text-base text-gray-500 font-semibold">
                        {{ driver.orderId }}
                      </p>

                      <div class="flex items-start mt-2">
                        <div class="flex flex-col items-center mr-1 mt-1">
                          <div
                            class="w-1 h-1 mb-1 rounded-full"
                            [ngClass]="{
                              'bg-transparent border-2 border-blue-500': driver.state === 'new_load',
                              'bg-blue-500':
                                driver.state === 'at_pickup' ||
                                driver.state === 'picked_up' ||
                                driver.state === 'at_drop_off'
                            }"
                          ></div>
                          <div
                            class="h-5 w-px"
                            [style.border]="
                              driver.state === 'new_load' || driver.state === 'at_pickup'
                                ? '1px dashed #3B82F6'
                                : 'none'
                            "
                            [style.background]="
                              driver.state === 'picked_up' || driver.state === 'at_drop_off' ? '#3B82F6' : 'transparent'
                            "
                          ></div>
                          <div
                            class="w-1 h-1 mt-1 rounded-full"
                            [ngClass]="{
                              'bg-transparent border-2 border-blue-500':
                                driver.state === 'new_load' ||
                                driver.state === 'at_pickup' ||
                                driver.state === 'picked_up',
                              'bg-blue-500': driver.state === 'at_drop_off'
                            }"
                          ></div>
                        </div>
                        <div class="flex-grow">
                          <div class="font-inter">
                            <div class="text-lightGray text-sm font-normal">Pick Up</div>
                            <div class="text-base font-medium">{{ driver.pickUp }}</div>
                          </div>

                          <div class="font-inter mb-2 mt-2">
                            <div class="text-lightGray text-sm font-normal">Drop off</div>
                            <div class="text-base font-medium">{{ driver.dropOff }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #noDriverInProgress> No driver in progress </ng-template>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="ON SHIFT" style="font-size: 12px">
            <div class="pl-2">
              <div class="flex-grow overflow-y-auto max-h-[300px] mt-5">
                <ng-container *ngIf="filteredDrivers.length; else noDriverOnShift">
                  <ng-container *ngFor="let driver of filteredDrivers; let i = index; trackBy: identifyDriver">
                    <div
                      class="py-1 cursor-pointer rounded-md pl-1"
                      [ngClass]="{ 'bg-lightBlue2': selectedDriver?.driverId === driver.driverId }"
                      (click)="selectDriver(driver)"
                    >
                      <div class="flex flex-row mb-1">
                        <div class="font-semibold text-blue-500 text-lg">
                          {{ driver.driverName }}
                        </div>
                        <div class="ml-auto mr-3">
                          <img
                            [src]="
                              driver.workingNights
                                ? './assets/icons/new-dashboard/night.svg'
                                : './assets/icons/new-dashboard/day.svg'
                            "
                            class="h-3 w-3"
                          />
                        </div>
                      </div>

                      <div class="font-inter mb-1">
                        <div class="text-lightGray text-sm font-normal">Shift Started At</div>
                        <div class="text-base font-medium">{{ driver.shiftStartAtString }}</div>
                      </div>

                      <div class="font-inter mb-1">
                        <div class="text-lightGray text-sm font-normal">HOS Remaining</div>
                        <div class="text-base font-medium">{{ driver.hosRemaining }}</div>
                      </div>

                      <div class="font-inter mb-2">
                        <div class="text-lightGray text-sm font-normal">Duration Since Last Completed Load</div>
                        <div class="text-base font-medium">{{ driver.durationSinceLastLoad }}</div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #noDriverOnShift> No driver on shift </ng-template>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="ON HITCH" style="font-size: 12px">
            <div class="pl-2">
              <div class="flex-grow overflow-y-auto max-h-[300px] mt-5">
                <ng-container *ngIf="filteredDrivers.length; else noDriverOnHitch">
                  <ng-container *ngFor="let driver of filteredDrivers; let i = index; trackBy: identifyDriver">
                    <div
                      class="py-1 cursor-pointer rounded-md pl-1"
                      [ngClass]="{ 'bg-lightBlue2': selectedDriver?.driverId === driver.driverId }"
                      (click)="selectDriver(driver)"
                    >
                      <div class="flex flex-row mb-1">
                        <div class="font-semibold text-blue-500 text-lg">
                          {{ driver.driverName }}
                        </div>
                        <div class="ml-auto mr-3">
                          <img
                            [src]="
                              driver.workingNights
                                ? './assets/icons/new-dashboard/night.svg'
                                : './assets/icons/new-dashboard/day.svg'
                            "
                            class="h-3 w-3"
                          />
                        </div>
                      </div>
                      <div class="font-inter mb-1">
                        <div class="text-lightGray text-sm font-normal">Hitch Period</div>
                        <div class="text-base font-medium" [innerHTML]="driver.hitchPeriod"></div>
                      </div>

                      <div class="font-inter mb-1">
                        <div class="text-lightGray text-sm font-normal">Current Status</div>
                        <div class="flex flex-row items-center">
                          <img
                            [src]="
                              driver.currentStatus === 'On Shift'
                                ? './assets/icons/new-dashboard/on_shift.svg'
                                : './assets/icons/new-dashboard/scheduled.svg'
                            "
                            style="height: 12px; width: 12px"
                          />
                          <div class="ml-1 text-base font-medium">{{ driver.currentStatus }}</div>
                        </div>
                      </div>

                      <div class="font-inter mb-1">
                        <div class="text-lightGray text-sm font-normal">Shifts Remaining</div>
                        <div class="text-base font-medium">{{ driver.shiftRemaining }}</div>
                      </div>

                      <div class="font-inter mb-2">
                        <div class="text-lightGray text-sm font-normal">Next Shift Start Time</div>
                        <div class="text-base font-medium">
                          {{ driver.nextShiftStartTime }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #noDriverOnHitch> No driver on hitch </ng-template>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </section>
</div>
